'use client';

import type { FC } from 'react';
import type { ParsedPlateEditorValue } from '@/utils/parsing.utils';
import { useTranslations } from 'next-intl';
import { PlateViewer } from 'packages/plate-viewer/src';

interface AboutProviderProps {
  contentValue: ParsedPlateEditorValue;
  isDetailedPage?: boolean;
}

export const AboutProvider: FC<AboutProviderProps> = ({ contentValue, isDetailedPage }) => {
  const t = useTranslations('providers');

  const title = t('about-providers', { count: isDetailedPage ? 1 : 2 });

  return (
    <section className="max-w-200">
      <h3 className="text-xl leading-[1.4] font-medium mb-6 text-light">{title}</h3>
      <PlateViewer value={contentValue} className="flex flex-col gap-2" />
    </section>

  );
};
